import {combineReducers} from 'redux';

import userReducer from './userReducer';
import {allPlayers,selectedPlayers} from './playerReducer';
import eventReducer from './eventReducer';
import {matchReducer,singleMatchReducer} from './matchReducer';

export default combineReducers({
    userId:userReducer,
    matches:matchReducer,
    selectedMatch:singleMatchReducer,
    players:allPlayers,
    selectedPlayers:selectedPlayers,
    events:eventReducer
})